import { useContext, useEffect, useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useDownloadCsvTransportationReportsApi, useFetchTransportationReportsApi } from 'api/transportation_report'
import { TransportationReport, TransportationReportSearchForm } from 'entities/transportation_report'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { transportationReportColumnInfoList, TransportationReportTableData } from './transportation_report_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { EditTransportationReportForm, NewTransportationReportForm } from './transportation_report_form'
import { Flex } from 'components/shared/flex'
import { useFetchVendorsApi } from 'api/vendor'
import { TransportationReportViewModel } from 'view_models/transportation_report_view_model'
import { Button, OverlayTrigger, ProgressBar, Tooltip } from 'react-bootstrap'
import { FaEdit } from 'react-icons/fa'

type Props = {
    history: H.History
}

const TransportationReportsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<TransportationReportSearchForm>()
    const searchForm = useForm<TransportationReportSearchForm>({ ...params, ordering: '-transportation_report_id' })
    const api = useFetchTransportationReportsApi(searchForm)
    const downloadCsvApi = useDownloadCsvTransportationReportsApi(searchForm)
    const checkIdForm = useMultipleCheckForm<TransportationReport>()
    const vendorsApi = useFetchVendorsApi()
    const [hoveredItem, setHoveredItem] = useState<TransportationReport>({})
    const [selectedItem, setSelectedItem] = useState<TransportationReport>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    let timeoutId: NodeJS.Timeout
    const transportationReportDisplaySetting = useDisplaySetting(
        transportationReportColumnInfoList(
            searchForm,
            vendorsApi.response.results.map((v) => {
                return { label: v.name, value: v.id! }
            })
        ),
        'TransportationReport'
    )

    useEffect(() => {
        api.execute()
        vendorsApi.execute()
    }, [])

    useEffect(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    const handleClickRemoveFilter = (key: keyof TransportationReportSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`transportation_reports?${queryParams}`)
        }
    }, [searchForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditTransportationReportForm
                transportationReport={selectedItem}
                onClose={() => {
                    setShowEdit(false)
                }}
                onComplete={() => {
                    setShowEdit(false)
                    api.execute()
                }}
                show={showEdit}
            />
            <ContentHeader
                headerTitle="搬送報告"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewTransportationReportForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['ordering']} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="flex-end">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={checkIdForm} showEdit>
                                <ActionTableCell th></ActionTableCell>
                                <TableHeads displaySetting={transportationReportDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading}>
                            {api.response.results.map((transportationReport: TransportationReport) => {
                                return (
                                    <CheckboxTableRow
                                        key={`transportationReport-${transportationReport.id}`}
                                        item={transportationReport}
                                        multipleCheckForm={checkIdForm}
                                    >
                                        <ActionTableCell
                                            onClick={() => {
                                                setSelectedItem(transportationReport)
                                                setShowEdit(true)
                                            }}
                                            action="edit"
                                        />
                                        <TransportationReportTableData
                                            transportationReport={transportationReport}
                                            displaySetting={transportationReportDisplaySetting}
                                        />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
                {/* <Flex flexWrap="wrap" style={{ marginBottom: 20 }}>
                    {api.response.results.map((transportationReport: TransportationReport) => {
                        return (
                            <ListItem
                                onMouseEnter={() => {
                                    clearTimeout(timeoutId)
                                    setHoveredItem(transportationReport)
                                }}
                                onMouseLeave={() => {
                                    clearTimeout(timeoutId)
                                    timeoutId = setTimeout(() => {
                                        setHoveredItem({})
                                    }, 50)
                                }}
                                key={'item-' + transportationReport.id}
                                transportationReport={transportationReport}
                                onClickReceipt={() => {
                                    props.history.push(`/inspections/transportation_reports/${transportationReport.id}/receipt`)
                                }}
                                onClickInput={() => {
                                    props.history.push(`/inspections/transportation_reports/${transportationReport.id}/input/`)
                                }}
                                onClickConfirm={() => {
                                    props.history.push(`/inspections/transportation_reports/${transportationReport.id}/confirm`)
                                }}
                                hovered={hoveredItem.id === transportationReport.id}
                                onClickEdit={() => {
                                    setSelectedItem(transportationReport)
                                    setShowEdit(true)
                                }}
                            />
                        )
                    })}
                </Flex> */}
            </ContentBody>

            <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                tableName="TransportationReport"
                hideFilterButton
            >
                <div>
                    <Button
                        onClick={() => {
                            props.history.push(`/inspections/transportation_reports/receipt?ids=${checkIdForm.ids().join(',')}`)
                        }}
                    >
                        検品画面へ
                    </Button>
                </div>
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(TransportationReportsPage)

type ListItemProps = {
    transportationReport: TransportationReport
    hovered?: boolean
    onMouseEnter?: () => void
    onMouseLeave?: () => void
    onClickReceipt: () => void
    onClickInput: () => void
    onClickConfirm: () => void
    onClickEdit: () => void
}

const ListItem = ({ transportationReport, hovered, onMouseEnter, onMouseLeave, onClickReceipt, onClickInput, onClickConfirm, onClickEdit }: ListItemProps) => {
    const vm = new TransportationReportViewModel(transportationReport)

    return (
        <div
            className="shadow"
            onMouseLeave={onMouseLeave}
            onMouseEnter={onMouseEnter}
            style={{ position: 'relative', padding: 20, backgroundColor: 'white', borderRadius: 5, marginBottom: 20, width: 250 }}
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    width: 30,
                    height: 30,
                    backgroundColor: '#f1f1f1',
                    borderRadius: 20,
                    textAlign: 'center',
                }}
                onClick={onClickEdit}
            >
                <FaEdit size={14} color="#888" />
            </Flex>
            <Flex justifyContent="space-between" style={{ marginBottom: 5 }}>
                <div>
                    <div style={{ fontSize: 10 }}>
                        ID: {transportationReport.id} / {transportationReport.vendor?.name}
                    </div>

                    <div style={{ fontWeight: 'bold' }}>{transportationReport.code || '-'}</div>
                </div>
            </Flex>
            <div style={{ fontSize: 12 }}>受入日: {vm.deliveryDateText()}</div>
            <div style={{ fontSize: 11 }}>受領者: {transportationReport.receiptUser?.fullName}</div>
            <Flex style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 11 }}>集荷: {vm.pickupDateText()}</div>
                <div style={{ fontSize: 11 }}>温度: {transportationReport.temperature}℃</div>
            </Flex>
            <Flex style={{ marginBottom: 10 }}>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 0, hide: 0 }}
                    overlay={
                        <Tooltip id="expire-tooltip">
                            <div style={{ margin: 0 }}>{transportationReport.note || '--'}</div>
                        </Tooltip>
                    }
                >
                    <div style={{ fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        備考: {transportationReport.note || '--'}
                    </div>
                </OverlayTrigger>
            </Flex>
            <div>
                <Flex alignItems="center">
                    <div style={{ flexGrow: 1 }}>
                        <ProgressBar variant="primary" now={vm.receiptRatio()} label={`${vm.receiptRatio()}%`}></ProgressBar>
                    </div>
                    <div style={{ fontSize: 10 }}>
                        {transportationReport.sampleSet?.length ?? 0} / {transportationReport.spitzCount}
                    </div>
                </Flex>
                <div style={{ marginTop: 10 }}>
                    {vm.receiptRatio() === 100 ? (
                        <Button disabled={vm.receiptRatio() === 100} variant="success" size="sm" onClick={onClickReceipt} style={{ width: '100%' }}>
                            入庫済
                        </Button>
                    ) : (
                        <Button disabled={vm.receiptRatio() === 100} variant="secondary" size="sm" onClick={onClickReceipt} style={{ width: '100%' }}>
                            入庫作業
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}
